/**
 * Persistence for the sidebar collapse preference (F-043 US3). A single browser
 * `localStorage` key holds `'collapsed' | 'expanded'`; any other/missing value (or
 * a storage failure in private-mode / over quota) is treated as the default,
 * `expanded`. Failures are swallowed silently — losing the preference is the only
 * consequence, the UI keeps working (mirrors `apps/web/src/lib/reopen-warning.ts`).
 */
const STORAGE_KEY = 'suvoda.sidebar-collapsed';

/** Read the persisted preference; `true` only when the stored value is `collapsed`. */
export function readCollapsed(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'collapsed';
  } catch {
    return false;
  }
}

/** Persist the preference as `collapsed`/`expanded`; a no-op (no throw) on failure. */
export function writeCollapsed(collapsed: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, collapsed ? 'collapsed' : 'expanded');
  } catch {
    // Quota / privacy-mode failures lose the flag, nothing else.
  }
}
